export default {
      id: "social-small-twitter-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#social-small-twitter",
      toString: function () {
        return this.url;
      }
    }